module.exports = __webpack_public_path__ + "static/media/verdeElephant.ac5f9731.jpg";